<div class="support-content">
  @if (showDeviceSubNav) {
  <ul class="nav nav-tabs detailed-tabs relative page-sub-heading" role="tablist">
    @if (showDeviceAdminLinks && permissionModules.includes('GROUP')) {
    <li class="nav-item" routerLinkActive="active">
      <a class="nav-link text-center mt-1 ml-4" [attr.href]="deviceBase + '/groups#groups'"
        [routerLink]="[deviceBase + '/groups']" routerLinkActive="active">
        <i class="fa fa-object-ungroup"></i> Groups
      </a>
    </li>
    }
    @if (showDeviceAdminLinks && permissionModules.includes('TAGS')) {
    <li class="nav-item" routerLinkActive="active">
      <a class="nav-link text-center mt-1 ml-4" [attr.href]="deviceBase + '/tags#tags'"
        [routerLink]="[deviceBase + '/tags']" routerLinkActive="active">
        <i class="fa fa-tags"></i> Tags
      </a>
    </li>
    }
    @if (showDeviceAdminLinks && permissionModules.includes('HEADER')) {
    <li class="nav-item" routerLinkActive="active">
      <a class="nav-link text-center mt-1 ml-4" [attr.href]="deviceBase + '/headers#attributes'"
        [routerLink]="[deviceBase + '/headers']" routerLinkActive="active">
        <i class="fa fa-sun-o"></i> Attributes
      </a>
    </li>
    }
  </ul>
  }

  @if (showOtaSubNav) {
  <nav class="connections-sidenav" aria-label="OTA navigation">
    <ul class="connections-sidenav__list" role="tablist">
      <li class="connections-sidenav__item" [class.active]="otaDashboardTabActive">
        <a [routerLink]="[otaBase]" [class.active]="otaDashboardTabActive"
          class="connections-sidenav__link" [attr.href]="otaBase + '#dashboard'">
          <i class="fa fa-th" aria-hidden="true"></i>
          <span>Dashboard</span>
        </a>
      </li>
      <li class="connections-sidenav__item" routerLinkActive="active">
        <a [routerLink]="[otaBase + '/campaign']" routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: false }"
          class="connections-sidenav__link" [attr.href]="otaBase + '/campaign#campaigns'">
          <i class="fa fa-bolt-lightning" aria-hidden="true"></i>
          <span>Campaigns</span>
        </a>
      </li>
      <li class="connections-sidenav__item" routerLinkActive="active">
        <a [routerLink]="[otaBase + '/files']" routerLinkActive="active"
          class="connections-sidenav__link" [attr.href]="otaBase + '/files#files'">
          <i class="fa fa-file" aria-hidden="true"></i>
          <span>Files</span>
        </a>
      </li>
    </ul>
  </nav>
  }

  @if (showDestinationSubNav) {
  <nav class="connections-sidenav" aria-label="Destination navigation">
    <ul class="connections-sidenav__list" role="tablist">
      <li class="connections-sidenav__item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
        <a [routerLink]="['/destinations']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
          class="connections-sidenav__link" href="#destinations">
          <i class="fa fa-sitemap" aria-hidden="true"></i>
          <span>Data Destinations</span>
        </a>
      </li>
      <li class="connections-sidenav__item" routerLinkActive="active">
        <a [routerLink]="['/destinations/data-schemes']" routerLinkActive="active"
          class="connections-sidenav__link" href="#schemes">
          <i class="fa fa-random" aria-hidden="true"></i>
          <span>Data Schemes</span>
        </a>
      </li>
      <li class="connections-sidenav__item" routerLinkActive="active">
        <a [routerLink]="['/destinations/replay-data']" routerLinkActive="active"
          class="connections-sidenav__link" href="#replay-data">
          <i class="fa fa-rotate-right" aria-hidden="true"></i>
          <span>Replay Data</span>
        </a>
      </li>
    </ul>
  </nav>
  }
</div>
